import { RunningExperiments, useExperiments } from 'state/experiments';

export const useLoyaltyOfferGroupsExperiment = (skipExposureLogging: boolean = false) => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.OfferGroups, 'treatment', {
    skipExposureLogging,
  });
};
